// Shared constants + helpers for the Invoice and Gate Pass modules.

export const INVOICE_STATUS_META = {
  draft:              { label: "Draft",              chip: "bg-[#98A2B3]/20 text-[#475467]" },
  issued:             { label: "Issued",             chip: "bg-[#a8dadc]/25 text-[#457b9d]" },
  partially_paid:     { label: "Partially Paid",     chip: "bg-[#FEF0C7] text-[#B54708]" },
  payment_pending:    { label: "Payment Pending",    chip: "bg-[#F79009]/15 text-[#B54708]" },
  paid:               { label: "Paid",               chip: "bg-[#12B76A]/12 text-[#0F9256]" },
  gate_pass_issued:   { label: "Gate Pass Issued",   chip: "bg-[#457b9d]/15 text-[#1d3557]" },
  closed:             { label: "Closed",             chip: "bg-[#1d3557]/10 text-[#1d3557]" },
  cancelled:          { label: "Cancelled",          chip: "bg-[#e63946]/12 text-[#e63946]" },
};

export const PAYMENT_STATUS_META = {
  unpaid:          { label: "Unpaid",          chip: "bg-[#e63946]/12 text-[#e63946]" },
  partially_paid:  { label: "Partially Paid",  chip: "bg-[#FEF0C7] text-[#B54708]" },
  paid:            { label: "Paid",            chip: "bg-[#12B76A]/12 text-[#0F9256]" },
};

export const GATE_PASS_STATUS_META = {
  draft:            { label: "Draft",           chip: "bg-[#98A2B3]/20 text-[#475467]" },
  ready_to_issue:   { label: "Ready to Issue",  chip: "bg-[#a8dadc]/25 text-[#457b9d]" },
  issued:           { label: "Issued",          chip: "bg-[#F79009]/15 text-[#B54708]" },
  vehicle_exited:   { label: "Vehicle Exited",  chip: "bg-[#12B76A]/12 text-[#0F9256]" },
  cancelled:        { label: "Cancelled",       chip: "bg-[#e63946]/12 text-[#e63946]" },
};

export const GST_RATES = [0, 5, 18];   // Phase-1 allowed slabs only

export const PAYMENT_METHODS = [
  { key: "cash", label: "Cash" },
  { key: "upi", label: "UPI" },
  { key: "card", label: "Card" },
  { key: "bank_transfer", label: "Bank" },
  { key: "cheque", label: "Cheque" },
  { key: "credit", label: "Credit" },
  { key: "other", label: "Other" },
];

export const OTHER_CHARGE_TYPES = [
  "Consumables", "Pickup Charge", "Drop Charge", "Towing",
  "Washing", "Wheel Alignment", "Wheel Balancing", "Diagnostic Charge",
  "Outside Work", "Handling Charge", "Miscellaneous",
];

export const FUEL_LEVELS = ["Empty", "1/4", "1/2", "3/4", "Full"];

export const HANDED_TO_TYPES = [
  { key: "customer", label: "Customer" },
  { key: "family", label: "Family Member" },
  { key: "driver", label: "Driver" },
  { key: "company_rep", label: "Company Representative" },
  { key: "insurance_rep", label: "Insurance Representative" },
  { key: "other", label: "Other" },
];

export function inr(n) {
  const v = Number(n) || 0;
  return `₹${v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function computeLocalTotals(items, invoiceType, isInterstate, discountAmount,
                                    discountPct, roundOff, advanceAmount) {
  let parts = 0, labour = 0, charges = 0;
  let lineDiscount = 0, taxable = 0, cgst = 0, sgst = 0, igst = 0;
  const nonGst = invoiceType !== "gst";
  for (const it of items) {
    const qty = Number(it.qty) || 0;
    const rate = Number(it.rate) || 0;
    const gross = qty * rate;
    const dPct = Number(it.discount_pct) || 0;
    const dAmt = dPct > 0 ? gross * dPct / 100 : (Number(it.discount_amount) || 0);
    const tx = Math.max(gross - dAmt, 0);
    const gr = nonGst ? 0 : (Number(it.gst_rate) || 0);
    if (nonGst) { /* no tax */ }
    else if (isInterstate) igst += tx * gr / 100;
    else { cgst += tx * gr / 200; sgst += tx * gr / 200; }
    const kind = it.kind || "part";
    if (kind === "part") parts += gross;
    else if (kind === "labour") labour += gross;
    else charges += gross;
    lineDiscount += dAmt; taxable += tx;
  }
  let invDisc = Number(discountAmount) || 0;
  if (Number(discountPct) > 0) invDisc = taxable * Number(discountPct) / 100;
  if (invDisc > 0 && taxable > 0) {
    const ratio = 1 - (invDisc / taxable);
    taxable = Math.max(taxable - invDisc, 0);
    cgst = cgst * ratio; sgst = sgst * ratio; igst = igst * ratio;
  }
  const total = taxable + cgst + sgst + igst + (Number(roundOff) || 0);
  const payable = Math.max(total - (Number(advanceAmount) || 0), 0);
  return {
    parts_subtotal: parts, labour_subtotal: labour, charges_subtotal: charges,
    gross_subtotal: parts + labour + charges,
    line_discount: lineDiscount, invoice_discount: invDisc,
    taxable, cgst, sgst, igst,
    round_off: Number(roundOff) || 0,
    invoice_total: total,
    advance_amount: Number(advanceAmount) || 0,
    amount_payable: payable,
  };
}
